<template>
  <nuxt-img
    :format="imgFormat"
    :densities="imgDensities"
    :sizes="imgSizes"
    :width="imgWidth"
    :height="imgHeight"
    :src="imgSrc"
    :placeholder="placeholderSrc"
    :alt="imgAlt"
    :loading="imgLoading"
    @error="handleError" />
</template>

<script setup lang="ts">
import { computed, ref } from "#imports";

const props = defineProps<{
  imgLoading?: String,
  imgFormat?: String,
  imgDensities?: String,
  imgSizes?: String,
  imgWidth?: String,
  imgHeight?: String,
  imgSrc?: String,
  imgPlaceholder?: String,
  imgAlt?: String,
}>();

const showPlaceholder = ref(false);

const placeholderSrc = computed<string|null>(() => {
  if (props.imgPlaceholder) {
    return props.imgPlaceholder;
  }

  return showPlaceholder.value ? props.imgSrc : null;
});

function handleError (): void {
  showPlaceholder.value = true;
}
</script>
